import {Button, ButtonProps, chain} from '@genestack/ui';
import React from 'react';

import {isDeletedDocument, isDocumentBeingEdited} from '../../../../../utils/document';

import {useStartEditingDocument} from './use-start-editing-document';

interface Props extends ButtonProps {
    document: EditModeDoc;
    onClickPublish: () => void;
}

/**
 * Component display control in header
 */
export function DocumentControl({document, onClickPublish, ...restProps}: Props) {
    const {startEditing, isDocEditable} = useStartEditingDocument({
        document
    });

    if (!isDocEditable || isDeletedDocument(document)) {
        return null;
    }

    if (isDocumentBeingEdited(document)) {
        return (
            <Button
                data-qa="doc-header-publish-button"
                {...restProps}
                onClick={chain(onClickPublish, restProps.onClick)}
            >
                Publish
            </Button>
        );
    }

    return (
        <Button data-qa="doc-header-edit-button" {...restProps} onClick={startEditing}>
            Edit
        </Button>
    );
}
